import React, {Component} from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Result from "./Result";
import {actions as label} from "../../reducers/label";
import FilterButton from "./FilterButton";

@connect(
    state => {
        return {
            selectedProject: state.project.selected,
            labels: state.label.labels,
            labelCollections: state.labelCollection.labelCollections,
            selectedLabelCollection: state.labelCollection.selected
        }
    },
    dispatch => {
        return {
            fetchAllLabels: () => dispatch(label.fetchAll()),
        }
    }
)
export default class SearchCardContent extends  Component
{
    static propTypes = {
        textInput: PropTypes.string
    };

    constructor(props) {
        super(props)

        this.state = {
            hasKey: true,
            hasValue: true,
            hasCollection: true
        };
    }

    getLabelFromKeyword(keyword) {
        return this.props.labels
            .filter(label =>
                (this.state.hasKey?label.name.toLowerCase().includes(keyword.toLowerCase()):null) ||
                (this.state.hasValue?label.defaultValue.toLowerCase().includes(keyword.toLowerCase()):null) ||
                (this.state.hasValue?JSON.stringify(label.translations).toLowerCase().includes(keyword.toLowerCase()):null)
            )
    }

    getCollectionFromKeyword(keyword) {
        if(!this.state.hasCollection) {
            return []
        }
        return this.props.labelCollections.filter(labelCollection => {
            return labelCollection.identifier.toLowerCase().includes(keyword.toLowerCase()) ||
                (labelCollection.displayName&&labelCollection.displayName.toLowerCase().includes(keyword.toLowerCase()))
        })
    }

    componentDidMount(nextProps, nextContext) {
        if(this.props.labels.length <= 0 || this.props.selectedLabelCollection === null) {
            this.props.fetchAllLabels()
        }
    }


    render() {
        const {textInput} = this.props;

        if(textInput.length<3) {
            return(
                <div>
                    Please enter minimum 3 characters to get results
                </div>
            )
        }

        const labelResult = this.getLabelFromKeyword(textInput)
        const collectionResult = this.getCollectionFromKeyword(textInput)

        if (labelResult.length<=0 && collectionResult.length<=0) {
            return (
                <div>
                    <FilterButton clickHandler={(checked) => this.setState({hasKey: checked})} name={'Label keys'}/>
                    <FilterButton clickHandler={(checked) => this.setState({hasValue: checked})} name={'Label values'}/>
                    <FilterButton clickHandler={(checked) => this.setState({hasCollection: checked})} name={'Collections'}/>
                    <hr/>
                    No results found
                </div>
            )
        }

        if(labelResult && collectionResult) {
            return (
                <div>
                    <FilterButton clickHandler={(checked) => this.setState({hasKey: checked})} name={'Label keys'}/>
                    <FilterButton clickHandler={(checked) => this.setState({hasValue: checked})} name={'Label values'}/>
                    <FilterButton clickHandler={(checked) => this.setState({hasCollection: checked})} name={'Collections'}/>
                    <Result labelResults={labelResult} collectionResult={collectionResult}/>
                </div>
            )
        }

        return null
    }
}



// WEBPACK FOOTER //
// ./React/src/components/LabelSearch/SearchCardContent.js